// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Trending2_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M21.75 19.5a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-15a.75.75 0 0 1 1.5 0v10.19l4.72-4.72a.75.75 0 0 1 1.06 0L12 12.44l4.94-4.94H15A.75.75 0 0 1 15 6h3.75a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V8.56l-5.47 5.47a.75.75 0 0 1-1.06 0L9 11.56l-5.25 5.25v1.94H21a.75.75 0 0 1 .75.75Z',
  viewBox: '0 0 24 24',
  glyph: 'Trending2_Stroke2_Corner2_Rounded',
})

export const Trending3_Stroke2_Corner1_Rounded = createSinglePathSVG({
  path: 'M22.5 5.25v6a.75.75 0 0 1-1.5 0V7.06l-7.72 7.72a.75.75 0 0 1-1.06 0L9 11.56l-6.22 6.22a.75.75 0 0 1-1.06-1.06l6.75-6.75a.75.75 0 0 1 1.06 0l3.22 3.22L19.94 6h-4.19a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75Z',
  viewBox: '0 0 24 24',
  glyph: 'Trending3_Stroke2_Corner1_Rounded',
})
